module.exports = __webpack_public_path__ + "media/images/flags/KG-a99aced501e865cd8c0f554108b3eef4.svg";